import commonService from './commonService'
import utils from './utils'

const getAll = async () => {
  const url = utils.url + '/organes'
  return await commonService.load(url, null, [])
}

const get = async (id, signal = null) => {
  return await commonService.get('organes', id, signal)
}

const countByOrgane = async (organeType, organeId, signal = null) => {
  const url = `${utils.url}/organes/count/${organeType}/${organeId}`
  return await commonService.load(url, signal, {})
}

const getByAddress = async (address, signal = null, axios = null) => {
  const url = `${utils.url}/organes/by_address/${JSON.stringify(address)}`
  return await commonService.load(url, signal, null, axios)
}

export default { getAll, get, countByOrgane, getByAddress }
